module.exports = __webpack_public_path__ + "media/images/mini-star-off-2a779b868b18f7f5e85bf2e9d495804e.svg";